// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import LaborAdditiveSummaryItem from './labor-additive-summary-item';
import {buildNumber} from '../../../../shared/services/build-number';

function handleShowMoreClick() {

    this.showHideMoreGroups(true);

}

const LaborAdditiveSummaryList = props =>
    <ul className='labor-additive-summary-list'>
        {props.laborAdditiveSummariesObject.alwaysShowGroup.map(laborAdditiveSummary =>
            <LaborAdditiveSummaryItem
                key={laborAdditiveSummary.group}
                laborAdditiveSummary={laborAdditiveSummary}
                onModalOpen={props.onModalOpen}
            />
        )}
        {props.laborAdditiveSummariesObject.showMoreGroup.length && !props.isMoreSummaryVisible ?
            <li
                className='show-more-groups'
                onClick={props::handleShowMoreClick}
            >
                <span className='show-more-groups-text'>
                    <FormattedMessage
                        id='SHOW_MORE_GROUPS'
                        values={{
                            count: props.count - 3,
                            countToDisplay: buildNumber(props.count - 3)
                        }}
                    />
                </span>
            </li> :
            null}
        {props.laborAdditiveSummariesObject.showMoreGroup.length && props.isMoreSummaryVisible ?
            <span className='show-more-list'>
                {props.laborAdditiveSummariesObject.showMoreGroup.map(laborAdditiveSummary =>
                    <LaborAdditiveSummaryItem
                        key={laborAdditiveSummary.group}
                        laborAdditiveSummary={laborAdditiveSummary}
                        onModalOpen={props.onModalOpen}
                    />
                )}
            </span> :
            null}
    </ul>;

LaborAdditiveSummaryList.displayName = 'LaborAdditiveSummaryList';
LaborAdditiveSummaryList.propTypes = {
    count: PropTypes.number.isRequired,
    isMoreSummaryVisible: PropTypes.bool.isRequired,
    laborAdditiveSummariesObject: PropTypes.shape({
        alwaysShowGroup: PropTypes.arrayOf(PropTypes.instanceOf(LaborAdditiveSummary)).isRequired,
        showMoreGroup: PropTypes.arrayOf(PropTypes.instanceOf(LaborAdditiveSummary)).isRequired
    }).isRequired,
    onModalOpen: PropTypes.func.isRequired,
    showHideMoreGroups: PropTypes.func.isRequired
};

export default LaborAdditiveSummaryList;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-summary/labor-additive-summary-list.js